import { observable } from "mobx";
import { Language } from "@/locales/zh_cn/";
import reactStringReplace from "react-string-replace";
import { defaultLocale } from "@/config.json";

export enum LangType {
  FA = "FA",
  ZH = "ZH",
  EN = "EN",
}

// 正则匹配有参数的形式
export class LocaleStore {
  // 当前使用的国际化map
  @observable public T: Language = {} as Language;
  @observable public lang: string;

  constructor() {
    // console.log("init-----------");

    const lang = localStorage.language || window.navigator.language || defaultLocale;
    this.T = this.getLocale(lang);
  }

  //这个可能不准确 , 后期看情况修改
  get getLangType() {
    return `${this.lang}`.slice(0, 2).toUpperCase() as LangType;
  }

  get getLangTypeLowerCase() {
    return this.getLangType.toLowerCase();
  }

  get isEqualToDefaultLocale() {
    return `${this.getLangType}` == defaultLocale;
  }

  get isCN() {
    return `${this.lang}`.includes("ZH");
  }

  getLocale(lang: string) {
    let result = {} as any;
    switch (lang) {
      case "fa":
      case "fa-IR":
      case LangType.FA:
        result = require("../locales/fa/");
        this.lang = LangType.FA;
        document.children[0].setAttribute("lang", "fa");
        const fontLink = document.createElement("link");
        fontLink.setAttribute("rel", "stylesheet");
        fontLink.setAttribute("type", "text/css");
        fontLink.setAttribute(
          "href",
          "https://cdn.jsdelivr.net/gh/rastikerdar/vazir-font@v26.0.2/dist/font-face.css"
        );
        document.head.appendChild(fontLink);
        break;
      case "zh":
      case "zh-TW":
      case "zh-CN":
      case "zh-HK":
      case "zh-SG":
      case "CN":
      case LangType.ZH:
        result = require("../locales/zh_cn/");
        this.lang = LangType.ZH;
        break;
      case "en-US":
      case "en":
      case LangType.EN:
        this.lang = LangType.EN;
        result = require("../locales/en/");
        break;
      // case "ja":
      // case "ja-JP":
      //   this.lang = "ja";
      //   result = require("../locales/ja/");
      //   break;
      default:
        result = require("../locales/zh_cn/");
        this.lang = LangType.ZH;
    }

    return result.default || result;
  }

  // 用来切换语言的函数
  setLocales(lang: LangType) {
    this.T = this.getLocale(lang);
    localStorage.language = lang;
    location.href = location.href;
  }

  // 对外暴露get函数，通过对应的key来获取
  get(key: keyof Language, returnEmpty = false) {
    let value = this.T && this.T[key];
    // console.log(this.T);

    if (!value) {
      return returnEmpty ? "" : key;
    }

    return value as string;
  }

  replace(key: keyof Language, values: object) {
    let formattedValue = this.T && (this.T[key] as any);

    if (!formattedValue) {
      return key;
    }

    // 替换变量
    if (values) {
      const replaceFunc = (match: string) => {
        if (values.hasOwnProperty(match)) {
          return values[match];
        }
        return match;
      };
      formattedValue = reactStringReplace(formattedValue, /[{|}]+/, replaceFunc);
    }

    return formattedValue;
  }
}

export default LocaleStore;
